import zaynPic from "@/public/images/artists/zayn.png";
import { Artist } from "@/types/types";

export const zayn = {
  id: "15",
  name: "Zayn",
  image: zaynPic,
  description: `Zayn will take on anything from Rap to Rnb and Pop. With a versatile approach that spans hip-hop and R&B, his voice exudes both smoothness and assertiveness. He effortlessly transitions between rhythmic verses and melodic hooks, showcasing his ability to balance intricate wordplay with catchy melodies.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fzayn-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop", "RnB"],
      secondary: ["Rapper"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 46,
        high: 70,
      },
    },
  },
} as const satisfies Artist;
